import { render, staticRenderFns } from "./Broadcast-Details.vue?vue&type=template&id=3adec33e"
import script from "./Broadcast-Details.vue?vue&type=script&lang=js"
export * from "./Broadcast-Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports